/**
 * Selector de Comunas + RUT + Facturacion — comprala.cl
 * ==========================================
 * INSTRUCCIONES DE INSTALACIÓN:
 * 1. En Shopify Admin > Online Store > Themes > Edit code
 * 2. Sube este archivo a Assets (Add a new asset > Upload file)
 * 3. Abre layout/theme.liquid
 * 4. Pega esto justo antes de </body>:
 *    <script src="{{ 'comprala-comunas.js' | asset_url }}" defer></script>
 * 5. Guarda y listo
 * ==========================================
 */

(function () {

  /* ── COMUNAS POR REGIÓN ─────────────────────────────────── */
  const REGIONES = {
    'Arica y Parinacota': ['Arica','Camarones','General Lagos','Putre'],
    'Tarapacá': ['Alto Hospicio','Camiña','Colchane','Huara','Iquique','Pica','Pozo Almonte'],
    'Antofagasta': ['Antofagasta','Calama','María Elena','Mejillones','Ollagüe','San Pedro de Atacama','Sierra Gorda','Taltal','Tocopilla'],
    'Atacama': ['Alto del Carmen','Caldera','Chañaral','Copiapó','Diego de Almagro','Freirina','Huasco','Tierra Amarilla','Vallenar'],
    'Coquimbo': ['Andacollo','Canela','Combarbalá','Coquimbo','Illapel','La Higuera','La Serena','Los Vilos','Monte Patria','Ovalle','Paiguano','Punitaqui','Río Hurtado','Salamanca','Vicuña'],
    'Valparaíso': ['Algarrobo','Cabildo','Calera','Calle Larga','Cartagena','Casablanca','Catemu','Concón','El Quisco','El Tabo','Hijuelas','Isla de Pascua','Juan Fernández','La Cruz','La Ligua','Limache','Llaillay','Los Andes','Nogales','Olmué','Panquehue','Papudo','Petorca','Puchuncaví','Putaendo','Quillota','Quilpué','Quintero','Rinconada','San Antonio','San Esteban','San Felipe','Santa María','Santo Domingo','Valparaíso','Villa Alemana','Viña del Mar','Zapallar'],
    'Metropolitana de Santiago': ['Alhué','Buin','Calera de Tango','Cerrillos','Cerro Navia','Colina','Conchalí','Curacaví','El Bosque','El Monte','Estación Central','Huechuraba','Independencia','Isla de Maipo','La Cisterna','La Florida','La Granja','La Pintana','La Reina','Lampa','Las Condes','Lo Barnechea','Lo Espejo','Lo Prado','Macul','Maipú','María Pinto','Melipilla','Ñuñoa','Padre Hurtado','Paine','Pedro Aguirre Cerda','Peñaflor','Peñalolén','Pirque','Providencia','Pudahuel','Puente Alto','Quilicura','Quinta Normal','Recoleta','Renca','San Bernardo','San Joaquín','San José de Maipo','San Miguel','San Pedro','San Ramón','Santiago','Talagante','Tiltil','Vitacura'],
    "O'Higgins": ['Chimbarongo','Chépica','Codegua','Coinco','Coltauco','Doñihue','Graneros','La Estrella','Las Cabras','Litueche','Lolol','Machalí','Malloa','Marchihue','Mostazal','Nancagua','Navidad','Olivar','Palmilla','Paredones','Peralillo','Peumo','Pichidegua','Pichilemu','Placilla','Pumanque','Quinta de Tilcoco','Rancagua','Rengo','Requínoa','San Fernando','San Vicente','Santa Cruz'],
    'Maule': ['Cauquenes','Chanco','Colbún','Constitución','Curepto','Curicó','Empedrado','Hualañé','Licantén','Linares','Longaví','Maule','Molina','Parral','Pelarco','Pelluhue','Pencahue','Rauco','Retiro','Río Claro','Romeral','Sagrada Familia','San Clemente','San Javier','San Rafael','Talca','Teno','Vichuquén','Villa Alegre','Yerbas Buenas'],
    'Ñuble': ['Bulnes','Chillán','Chillán Viejo','Cobquecura','Coelemu','Coihueco','El Carmen','Ninhue','Ñiquén','Pemuco','Pinto','Portezuelo','Quillón','Quirihue','Ránquil','San Carlos','San Fabián','San Ignacio','San Nicolás','Treguaco','Yungay'],
    'Biobío': ['Alto Biobío','Antuco','Arauco','Cabrero','Cañete','Concepción','Contulmo','Coronel','Curanilahue','Florida','Hualpén','Hualqui','Laja','Lebu','Los Álamos','Los Ángeles','Lota','Mulchén','Nacimiento','Negrete','Penco','Quilaco','Quilleco','San Pedro de la Paz','San Rosendo','Santa Bárbara','Santa Juana','Talcahuano','Tirúa','Tomé','Tucapel','Yumbel'],
    'La Araucanía': ['Angol','Carahue','Cholchol','Collipulli','Cunco','Curacautín','Curarrehue','Ercilla','Freire','Galvarino','Gorbea','Lautaro','Loncoche','Lonquimay','Los Sauces','Lumaco','Melipeuco','Nueva Imperial','Padre las Casas','Perquenco','Pitrufquén','Pucón','Purén','Renaico','Saavedra','Temuco','Teodoro Schmidt','Toltén','Traiguén','Victoria','Vilcún','Villarrica'],
    'Los Ríos': ['Corral','Futrono','La Unión','Lagos','Lanco','Los Lagos','Máfil','Mariquina','Paillaco','Panguipulli','Río Bueno','Valdivia'],
    'Los Lagos': ['Ancud','Calbuco','Castro','Chaitén','Chonchi','Cochamó','Curaco de Vélez','Dalcahue','Fresia','Frutillar','Futaleufú','Hualaihué','Llanquihue','Los Muermos','Maullín','Osorno','Palena','Puerto Montt','Puerto Octay','Puerto Varas','Puqueldón','Purranque','Puyehue','Queilén','Quellón','Quemchi','Quinchao','Río Negro','San Juan de la Costa','San Pablo'],
    'Aysén': ['Aysén','Chile Chico','Cisnes','Cochrane','Coyhaique','Guaitecas',"O'Higgins",'Lago Verde','Río Ibáñez','Tortel'],
    'Magallanes': ['Antártica','Cabo de Hornos','Laguna Blanca','Natales','Punta Arenas','Río Verde','San Gregorio','Timaukel','Torres del Paine'],
  };

  /* ── VALIDADOR DE RUT ───────────────────────────────────── */
  function validarRut(rut) {
    rut = rut.replace(/\./g,'').replace(/-/g,'').trim().toUpperCase();
    if (rut.length < 2) return false;
    const cuerpo = rut.slice(0,-1);
    const dv = rut.slice(-1);
    if (!/^\d+$/.test(cuerpo)) return false;
    let suma = 0, multiplo = 2;
    for (let i = cuerpo.length-1; i >= 0; i--) {
      suma += parseInt(cuerpo[i]) * multiplo;
      multiplo = multiplo === 7 ? 2 : multiplo + 1;
    }
    const dvEsperado = 11 - (suma % 11);
    const dvStr = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : String(dvEsperado);
    return dv === dvStr;
  }

  function formatearRut(rut) {
    rut = rut.replace(/\./g,'').replace(/-/g,'').trim();
    if (rut.length < 2) return rut;
    const cuerpo = rut.slice(0,-1).replace(/\B(?=(\d{3})+(?!\d))/g,'.');
    const dv = rut.slice(-1).toUpperCase();
    return cuerpo + '-' + dv;
  }

  function aplicarFormatoRut(input) {
    let val = input.value.replace(/[^0-9kK]/g,'');
    if (val.length > 1) {
      const cuerpo = val.slice(0,-1).replace(/\B(?=(\d{3})+(?!\d))/g,'.');
      const dv = val.slice(-1).toUpperCase();
      input.value = cuerpo + '-' + dv;
    } else {
      input.value = val;
    }
  }

  /* ── ESTILOS ────────────────────────────────────────────── */
  const CSS = `
    #cmp-comunas-wrap {
      margin: 16px 0;
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 16px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      background: #fafafa;
    }
    #cmp-titulo {
      font-size: 13px;
      font-weight: 600;
      color: #FF6B1A;
      margin-bottom: 2px;
    }
    .cmp-field-label {
      display: block;
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 5px;
      color: #333;
    }
    .cmp-required { color: #e53e3e; margin-left: 2px; }
    #cmp-region-select, #cmp-comuna-select, #cmp-rut-input, #cmp-rut-empresa-input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size: 14px;
      background: #fff;
      color: #333;
      box-sizing: border-box;
      transition: border-color .2s;
    }
    #cmp-region-select, #cmp-comuna-select {
      appearance: none; -webkit-appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 12px center;
      cursor: pointer;
    }
    #cmp-region-select:focus, #cmp-comuna-select:focus,
    #cmp-rut-input:focus, #cmp-rut-empresa-input:focus {
      outline: none;
      border-color: #FF6B1A;
      box-shadow: 0 0 0 2px rgba(255,107,26,0.15);
    }
    .cmp-error { border-color: #e53e3e !important; box-shadow: 0 0 0 2px rgba(229,62,62,0.15) !important; }
    .cmp-ok    { border-color: #38a169 !important; }
    #cmp-comuna-select:disabled { opacity: 0.5; cursor: not-allowed; }
    .cmp-field-error { font-size: 11px; color: #e53e3e; margin-top: 4px; display: none; }
    .cmp-field-error.visible { display: block; }
    .cmp-hint { font-size: 11px; color: #888; margin-top: 4px; }
    #cmp-factura-check-wrap {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 12px;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      cursor: pointer;
    }
    #cmp-factura-check-wrap input[type="checkbox"] {
      width: 16px; height: 16px; cursor: pointer; accent-color: #FF6B1A;
    }
    #cmp-factura-check-wrap label {
      font-size: 13px; color: #333; cursor: pointer; margin: 0;
    }
    #cmp-factura-fields {
      display: none;
      flex-direction: column;
      gap: 12px;
      padding: 12px;
      background: #fff8f5;
      border: 1px solid #FF6B1A44;
      border-radius: 6px;
    }
    #cmp-factura-fields.visible { display: flex; }
  `;

  const style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  /* ── CREAR WIDGET ───────────────────────────────────────── */
  function crearWidget() {
    const wrap = document.createElement('div');
    wrap.id = 'cmp-comunas-wrap';
    wrap.innerHTML = `
      <div id="cmp-titulo">Datos de despacho requeridos</div>

      <div>
        <label class="cmp-field-label" for="cmp-region-select">Region <span class="cmp-required">*</span></label>
        <select id="cmp-region-select">
          <option value="">-- Selecciona tu region --</option>
          ${Object.keys(REGIONES).map(r => `<option value="${r}">${r}</option>`).join('')}
        </select>
        <p class="cmp-field-error" id="cmp-region-error">Por favor selecciona una region</p>
      </div>

      <div>
        <label class="cmp-field-label" for="cmp-comuna-select">Comuna <span class="cmp-required">*</span></label>
        <select id="cmp-comuna-select" disabled>
          <option value="">-- Primero selecciona una region --</option>
        </select>
        <p class="cmp-field-error" id="cmp-comuna-error">Por favor selecciona una comuna</p>
      </div>

      <div>
        <label class="cmp-field-label" for="cmp-rut-input">RUT <span class="cmp-required">*</span></label>
        <input id="cmp-rut-input" type="text" placeholder="Ej: 12.345.678-9" maxlength="12" autocomplete="off" />
        <p class="cmp-hint">Formato: 12.345.678-9</p>
        <p class="cmp-field-error" id="cmp-rut-error">RUT invalido, verifica el formato y digito verificador</p>
      </div>

      <div id="cmp-factura-check-wrap">
        <input type="checkbox" id="cmp-factura-check" />
        <label for="cmp-factura-check">Necesito factura en vez de boleta</label>
      </div>

      <div id="cmp-factura-fields">
        <div>
          <label class="cmp-field-label" for="cmp-rut-empresa-input">RUT empresa <span class="cmp-required">*</span></label>
          <input id="cmp-rut-empresa-input" type="text" placeholder="Ej: 76.543.210-K" maxlength="12" autocomplete="off" />
          <p class="cmp-hint">RUT de la empresa para emitir la factura</p>
          <p class="cmp-field-error" id="cmp-rut-empresa-error">RUT empresa invalido, verifica el formato y digito verificador</p>
        </div>
      </div>
    `;
    return wrap;
  }

  /* ── LÓGICA ─────────────────────────────────────────────── */
  function iniciarLogica(boton) {
    const regionSel      = document.getElementById('cmp-region-select');
    const comunaSel      = document.getElementById('cmp-comuna-select');
    const rutInput       = document.getElementById('cmp-rut-input');
    const facturaCheck   = document.getElementById('cmp-factura-check');
    const facturaFields  = document.getElementById('cmp-factura-fields');
    const rutEmpresaInput= document.getElementById('cmp-rut-empresa-input');

    /* Región → comunas */
    regionSel.addEventListener('change', function () {
      const region = this.value;
      document.getElementById('cmp-region-error').classList.remove('visible');
      comunaSel.classList.remove('cmp-error','cmp-ok');
      comunaSel.innerHTML = '';
      if (!region) {
        regionSel.classList.remove('cmp-ok');
        comunaSel.innerHTML = '<option value="">-- Primero selecciona una region --</option>';
        comunaSel.disabled = true;
        return;
      }
      regionSel.classList.add('cmp-ok');
      regionSel.classList.remove('cmp-error');
      comunaSel.innerHTML = '<option value="">-- Selecciona tu comuna --</option>' +
        (REGIONES[region]||[]).map(c=>`<option value="${c}">${c}</option>`).join('');
      comunaSel.disabled = false;
      try { sessionStorage.setItem('cmp_region', region); } catch(e) {}
    });

    /* Comuna */
    comunaSel.addEventListener('change', function () {
      document.getElementById('cmp-comuna-error').classList.remove('visible');
      if (!this.value) { comunaSel.classList.remove('cmp-ok'); return; }
      comunaSel.classList.add('cmp-ok');
      comunaSel.classList.remove('cmp-error');
      const campoCity = document.querySelector(
        'input[name="checkout[shipping_address][city]"],input[name="address[city]"],input[autocomplete="address-level2"],#checkout_shipping_address_city'
      );
      if (campoCity) {
        campoCity.value = this.value;
        campoCity.dispatchEvent(new Event('input',{bubbles:true}));
        campoCity.dispatchEvent(new Event('change',{bubbles:true}));
      }
      try { sessionStorage.setItem('cmp_comuna', this.value); } catch(e) {}
    });

    /* RUT personal */
    rutInput.addEventListener('input', function () {
      aplicarFormatoRut(this);
      document.getElementById('cmp-rut-error').classList.remove('visible');
      rutInput.classList.remove('cmp-error','cmp-ok');
    });
    rutInput.addEventListener('blur', function () {
      if (!this.value) return;
      if (validarRut(this.value)) {
        this.value = formatearRut(this.value.replace(/\./g,'').replace(/-/g,''));
        rutInput.classList.add('cmp-ok'); rutInput.classList.remove('cmp-error');
        document.getElementById('cmp-rut-error').classList.remove('visible');
        try { sessionStorage.setItem('cmp_rut', this.value); } catch(e) {}
      } else {
        rutInput.classList.add('cmp-error'); rutInput.classList.remove('cmp-ok');
        document.getElementById('cmp-rut-error').classList.add('visible');
      }
    });

    /* Checkbox factura */
    facturaCheck.addEventListener('change', function () {
      if (this.checked) {
        facturaFields.classList.add('visible');
      } else {
        facturaFields.classList.remove('visible');
        rutEmpresaInput.value = '';
        rutEmpresaInput.classList.remove('cmp-error','cmp-ok');
        document.getElementById('cmp-rut-empresa-error').classList.remove('visible');
      }
      try { sessionStorage.setItem('cmp_factura', this.checked ? '1' : '0'); } catch(e) {}
    });

    /* RUT empresa */
    rutEmpresaInput.addEventListener('input', function () {
      aplicarFormatoRut(this);
      document.getElementById('cmp-rut-empresa-error').classList.remove('visible');
      rutEmpresaInput.classList.remove('cmp-error','cmp-ok');
    });
    rutEmpresaInput.addEventListener('blur', function () {
      if (!this.value) return;
      if (validarRut(this.value)) {
        this.value = formatearRut(this.value.replace(/\./g,'').replace(/-/g,''));
        rutEmpresaInput.classList.add('cmp-ok'); rutEmpresaInput.classList.remove('cmp-error');
        document.getElementById('cmp-rut-empresa-error').classList.remove('visible');
        try { sessionStorage.setItem('cmp_rut_empresa', this.value); } catch(e) {}
      } else {
        rutEmpresaInput.classList.add('cmp-error'); rutEmpresaInput.classList.remove('cmp-ok');
        document.getElementById('cmp-rut-empresa-error').classList.add('visible');
      }
    });

    /* Validar al hacer checkout */
    if (boton) {
      boton.addEventListener('click', function (e) {
        let valido = true;

        if (!regionSel.value) {
          regionSel.classList.add('cmp-error');
          document.getElementById('cmp-region-error').classList.add('visible');
          valido = false;
        }
        if (!comunaSel.value) {
          comunaSel.classList.add('cmp-error');
          document.getElementById('cmp-comuna-error').classList.add('visible');
          valido = false;
        }
        if (!rutInput.value || !validarRut(rutInput.value)) {
          rutInput.classList.add('cmp-error');
          document.getElementById('cmp-rut-error').classList.add('visible');
          valido = false;
        }
        if (facturaCheck.checked && (!rutEmpresaInput.value || !validarRut(rutEmpresaInput.value))) {
          rutEmpresaInput.classList.add('cmp-error');
          document.getElementById('cmp-rut-empresa-error').classList.add('visible');
          valido = false;
        }

        if (!valido) {
          e.preventDefault();
          e.stopPropagation();
          document.getElementById('cmp-comunas-wrap').scrollIntoView({ behavior:'smooth', block:'center' });
          return false;
        }

        /* Guardar atributos en el carrito de Shopify */
        const attrs = {
          'Comuna': comunaSel.value,
          'Region': regionSel.value,
          'RUT': rutInput.value,
          'Tipo documento': facturaCheck.checked ? 'Factura' : 'Boleta',
        };
        if (facturaCheck.checked) attrs['RUT Empresa'] = rutEmpresaInput.value;

        try {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        } catch(e) {}
      }, true);
    }
  }

  /* ── INSERTAR EN CARRITO ────────────────────────────────── */
  function insertar() {
    if (document.getElementById('cmp-comunas-wrap')) return;

    const boton =
      Array.from(document.querySelectorAll('button')).find(b => b.textContent.trim() === 'Pagar') ||
      document.querySelector('[name="checkout"]') ||
      document.querySelector('button[type="submit"][name="checkout"]') ||
      document.querySelector('.cart__checkout-button') ||
      document.querySelector('.cart__checkout') ||
      document.querySelector('form[action="/checkout"] [type="submit"]') ||
      document.querySelector('input[name="checkout"]');

    if (!boton) return;

    const padre = boton.parentElement;
    if (!padre) return;

    const widget = crearWidget();
    padre.insertBefore(widget, boton);
    iniciarLogica(boton);

    /* Recuperar sesión previa */
    try {
      const rp = sessionStorage.getItem('cmp_region');
      const cp = sessionStorage.getItem('cmp_comuna');
      const rut = sessionStorage.getItem('cmp_rut');
      const fac = sessionStorage.getItem('cmp_factura');
      const rutEmp = sessionStorage.getItem('cmp_rut_empresa');
      const rs = document.getElementById('cmp-region-select');
      const cs = document.getElementById('cmp-comuna-select');
      const ri = document.getElementById('cmp-rut-input');
      const fc = document.getElementById('cmp-factura-check');
      const rei = document.getElementById('cmp-rut-empresa-input');

      if (rp && rs) { rs.value = rp; rs.dispatchEvent(new Event('change')); }
      if (cp && cs) { setTimeout(()=>{ cs.value = cp; cs.dispatchEvent(new Event('change')); }, 60); }
      if (rut && ri) ri.value = rut;
      if (fac === '1' && fc) { fc.checked = true; fc.dispatchEvent(new Event('change')); }
      if (rutEmp && rei) rei.value = rutEmp;
    } catch(e) {}
  }

  function init() {
    insertar();
    const obs = new MutationObserver(()=>{ if (!document.getElementById('cmp-comunas-wrap')) insertar(); });
    obs.observe(document.body, { childList:true, subtree:true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
